import React from 'react';
import { ListItem, ListItemAvatar, ListItemText, Typography, Avatar, Box } from '@material-ui/core';
import DesktopWindowsIcon from '@material-ui/icons/DesktopWindows';
import { formatSessionTimeRange } from '../utils';

export function SessionListItem({ session, selected, onClick, classes }) {
	const { timeRange, dateStr } = formatSessionTimeRange(session.accessedAt, session.endedAt);
	const isActive = session.endedAt == null;

	return (
		<ListItem
			className={`${classes.sessionItem} ${selected ? 'selected' : ''}`}
			onClick={onClick}
			button
		>
			<ListItemAvatar>
				<Avatar className={classes.avatarSession}>
					{session.name.split(' ').map((n) => n[0]).join('')}
				</Avatar>
			</ListItemAvatar>
			<ListItemText
				primary={
					<Typography variant="body2" style={{ fontWeight: 500 }}>{session.name}</Typography>
				}
				secondary={
					<>
						<Box component="span" display="flex" alignItems="center" flexWrap="wrap">
							<Typography variant="body2" color="textSecondary" component="span">{timeRange}</Typography>
							{isActive && (
								<span style={{ width: 8, height: 8, borderRadius: '50%', backgroundColor: '#4caf50', marginLeft: 6, flexShrink: 0 }} title="Active session" />
							)}
						</Box>
						{dateStr && <Typography variant="caption" color="textSecondary" display="block">{dateStr}</Typography>}
						<Box className={classes.sessionMeta} display="flex" alignItems="center" gap={0.5}>
							<DesktopWindowsIcon style={{ fontSize: 14 }} /> {session.device}
						</Box>
						<Typography variant="caption" color="textSecondary">
							{session.pages} Pages • {session.actions} Actions
						</Typography>
					</>
				}
			/>
		</ListItem>
	);
}
